export class ProcLinkModel {
    proc_no?: string
    intModRow: string
    code_name: string
    link_no: string
    link_type: string
    link_sequence: string
    link_category: string
    link_active: string
    link_weight1: string
    link_weight2: string
    link_age1: string
    link_age2: string
    link_specie: string
    link_sex: string
    link_rec_fix: string
    link_dosage: string
    link_chk_price: string
    link_reg_price: string
    link_price: string
    link_basechg: string
    link_add_price: string
    link_variance: string
    link_frequency: string
    link_sub_hist: boolean
    link_printable: boolean
    link_sale_treat: string
    link_clinic: string
    link_breed: string
    link_rescueprice: string
    link_altdays: string
    link_mindose: string
    link_maxdose: string
    link_indicationID: string
    link_notes: string
    link_days: string
    link_id :string
    indications: string
    link_dosageunit: string
    specie_name:string
    breed_name: string

    constructor(
        code_name: string,
        link_no: string,
        link_type: string,
        link_sequence: string,
        link_category: string,
        link_active: string,
        link_weight1: string,
        link_weight2: string,
        link_age1: string,
        link_age2: string,
        link_specie: string,
        link_sex: string,
        link_rec_fix: string,
        link_dosage: string,
        link_chk_price: string,
        link_reg_price: string,
        link_price: string,
        link_basechg: string,
        link_add_price: string,
        link_variance: string,
        link_frequency: string,
        link_sub_hist: boolean,
        link_printable: boolean,
        link_sale_treat: string,
        link_clinic: string,
        link_breed: string,
        link_rescueprice: string,
        link_altdays: string,
        link_mindose: string,
        link_maxdose: string,
        link_indicationID: string,
        link_notes: string,
        link_days:string,
        link_id: string,
        indications : string,
        link_dosageunit: string,
        specie_name:string,
        breed_name: string,
        proc_no: string,
    ) {
        this.code_name = code_name
        this.link_no = link_no
        this.link_type = link_type
        this.link_sequence = link_sequence
        this.link_category = link_category
        this.link_active = link_active
        this.link_weight1 = link_weight1
        this.link_weight2 = link_weight2
        this.link_age1 = link_age1
        this.link_age2 = link_age2
        this.link_specie = link_specie
        this.link_sex = link_sex
        this.link_rec_fix = link_rec_fix
        this.link_dosage = link_dosage
        this.link_chk_price = link_chk_price
        this.link_reg_price = link_reg_price
        this.link_price = link_price
        this.link_basechg = link_basechg
        this.link_add_price = link_add_price
        this.link_variance = link_variance
        this.link_frequency = link_frequency
        this.link_sub_hist = link_sub_hist
        this.link_printable = link_printable
        this.link_sale_treat = link_sale_treat
        this.link_clinic = link_clinic
        this.link_breed = link_breed
        this.link_rescueprice = link_rescueprice
        this.link_altdays = link_altdays
        this.link_mindose = link_mindose
        this.link_maxdose = link_maxdose
        this.link_indicationID = link_indicationID
        this.link_notes = link_notes
        this.link_days = link_days
        this.link_id = link_id
        this.indications = indications
        this.link_dosageunit = link_dosageunit
        this.specie_name=specie_name
        this.breed_name=breed_name
        this.proc_no=proc_no
    }
}